import { render, staticRenderFns } from "./partyBPage.vue?vue&type=template&id=5aa58a82&scoped=true"
import script from "./partyBPage.vue?vue&type=script&lang=js"
export * from "./partyBPage.vue?vue&type=script&lang=js"
import style0 from "./partyBPage.vue?vue&type=style&index=0&id=5aa58a82&prod&lang=css"
import style1 from "./partyBPage.vue?vue&type=style&index=1&id=5aa58a82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa58a82",
  null
  
)

export default component.exports